import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js'

// ----------------- 帧率监测 -----------------
import Stats from 'three/examples/js/libs/stats.min.js'
const stats = new Stats()
stats.setMode(0)
stats.domElement.style.position = 'absolute'
stats.domElement.style.left = '0px'
stats.domElement.style.top = '0px'
// document.body.appendChild(stats.dom)
const clock = new THREE.Clock() //计时器
const FPS = 60 // 指的是 60帧每秒的情况
const singleFrameTime = 1 / FPS
let timeStamp = 0
// ---------------------------------------------

let camera = null
let renderer = null
let scene = null
let controls = null
let pmremGenerator = null;
let eventRender = { name: "renderHandler", funcArr: [] };
export const initThreejs = (option) => {
  //绑定事件
  window.addEventListener('resize', onWindowResize)
  //容器
  // let container = option.container.value //容器
  //渲染器
  renderer = new THREE.WebGLRenderer({ 
    antialias: true, 
    logarithmicDepthBuffer: true, 
    preserveDrawingBuffer: true
  }) //渲染器
  renderer.setPixelRatio(window.devicePixelRatio) //更清晰
  renderer.setSize(window.innerWidth, window.innerHeight) //渲染器大小
  renderer.setAnimationLoop(render) //循环执行
  renderer.outputEncoding = THREE.sRGBEncoding //渲染器编码，一般3D都需要这个！跟默认值不同。
  renderer.toneMapping = THREE.ACESFilmicToneMapping
  renderer.toneMappingExposure = 0.85
  // renderer.debug.checkShaderErrors = false;
  // renderer.info.autoReset = false;
  option.container.appendChild(renderer.domElement)
  //相机
  camera = new THREE.PerspectiveCamera(
    40,
    window.innerWidth / window.innerHeight,
    1,
    2000
  )
  camera.cameraPerspectiveAuto = true
  camera.up = new THREE.Vector3(0, 0, 1)
  //轨道控制
  controls = new OrbitControls(camera, renderer.domElement)
  controls.update()
  controls.minPolarAngle = 0
  controls.maxPolarAngle = Math.PI / 2
  controls.enablePan = false
  controls.enableRotate = true
  controls.mouseButtons = {
    LEFT: THREE.MOUSE.ROTATE,
    MIDDLE: THREE.MOUSE.DOLLY,
    RIGHT: THREE.MOUSE.PAN
  }
  window.camera = camera
  //纹理
  pmremGenerator = new THREE.PMREMGenerator(renderer)
  //场景
  scene = new THREE.Scene()
  scene.environment = pmremGenerator.fromScene(new RoomEnvironment()).texture

  let groupMap = new THREE.Group();
  scene.add(groupMap)
  let groupMap_local = new THREE.Group();
  scene.add(groupMap_local)

  let groupScene = new THREE.Group();
  scene.add(groupScene)
  // 初始化光源
  initLight()
  eventRender.funcArr=[];
  return {
    camera,
    renderer,
    controls,
    pmremGenerator,
    scene: groupScene,
    groupMap,
    groupMap_local,
    scene_source: scene,
    eventRender
  }
}

export const initLight = () => {
  // 环境光
  const light = new THREE.AmbientLight(0x0c0c0c) // soft white light
  scene.add(light)

  // 聚光灯
  const spotLight = new THREE.SpotLight()
  spotLight.color = new THREE.Color(0xfdf5e6)
  spotLight.castShadow = true
  spotLight.position.set(-80, 60, -10)
  // 光的强度 默认值为1
  spotLight.intensity = 1
  // 从发光点发出的距离，光的亮度，会随着距离的远近线性衰减
  spotLight.distance = 350
  // 光色散角度，默认是 Math.PI * 2
  spotLight.angle = 0.4
  // 光影的减弱程度，默认值为0， 取值范围 0 -- 1之间
  spotLight.penumbra = 0.1
  // 光在距离上的量值, 和光的强度类似（衰减指数）
  spotLight.decay = 1
  // 设置阴影分辨率
  spotLight.shadow.mapSize.width = 1024
  spotLight.shadow.mapSize.height = 1024
  // 投影近点 --> 从距离光源的哪一才产生阴影
  spotLight.shadow.camera.near = 0.1
  // 投影原点 --> 到光源的哪一点位置不产生阴影
  spotLight.shadow.camera.far = 300
  // 投影视场
  spotLight.shadow.camera.fov = 40
  scene.add(spotLight)

  // 平行光，距离很远的光，类似太阳光
  const DirectionalLight = new THREE.DirectionalLight(0xfdf5e6, 1, 0)
  // 位置不同，方向光作用于物体的面也不同，看到的物体各个面的颜色也不一样
  DirectionalLight.position.set(0, 0, 1) //光源的向量，即光源的位置
  scene.add(DirectionalLight) //追加光源到场景

  // 点光，类似灯泡
  const PointLight = new THREE.PointLight(0xfdf5e6)
  PointLight.position.set(0, 0, 1)
  PointLight.distance = 100 // 设置点光源照射距离为100
  PointLight.castShadow = true //告诉平行光需要开启阴影投射
  scene.add(PointLight)
}

const onWindowResize = () => {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()
  renderer.setSize(window.innerWidth, window.innerHeight)
}

//循环渲染
const render = () => {
  const delta = clock.getDelta()
  timeStamp += delta
  if (timeStamp > singleFrameTime) {
    stats.begin()
    if (controls) controls.update()
    renderer.render(scene, camera)
    timeStamp = timeStamp % singleFrameTime
    stats.end()
  }
  if (eventRender) {
    eventRender.funcArr.forEach(f=>{
      f();
    })
  }
}

export const reloadThreejs = () => {
  // scene.environment = pmremGenerator.fromScene(new RoomEnvironment()).texture
  // window.addEventListener('resize', onWindowResize)
  //容器
  // let container = option.container.value //容器
  //渲染器
  // renderer = new THREE.WebGLRenderer({ antialias: true, logarithmicDepthBuffer: true }) //渲染器
  renderer.setPixelRatio(window.devicePixelRatio) //更清晰
  renderer.setSize(window.innerWidth, window.innerHeight) //渲染器大小
  renderer.setAnimationLoop(render) //循环执行
  renderer.outputEncoding = THREE.sRGBEncoding //渲染器编码，一般3D都需要这个！跟默认值不同。
  renderer.toneMapping = THREE.ACESFilmicToneMapping
  renderer.toneMappingExposure = 0.85
  // renderer.info.autoReset = false;
  // option.container.appendChild(renderer.domElement)
  //相机
  // camera = new THREE.PerspectiveCamera(
  //   40,
  //   window.innerWidth / window.innerHeight,
  //   1,
  //   2000
  // )
  // camera.up = new THREE.Vector3(0, 0, 1)
  //轨道控制
  // controls = new OrbitControls(camera, renderer.domElement)
  // controls.update()
  // controls.minPolarAngle = 0
  // controls.maxPolarAngle = Math.PI / 2
  // controls.enablePan = false
  // controls.enableRotate = true
  // controls.mouseButtons = {
  //   LEFT: THREE.MOUSE.ROTATE,
  //   MIDDLE: THREE.MOUSE.DOLLY,
  //   RIGHT: THREE.MOUSE.PAN
  // }
  // window.camera = camera
  //纹理
  pmremGenerator = new THREE.PMREMGenerator(renderer)
  //场景
  // scene = new THREE.Scene()
  scene.environment = pmremGenerator.fromScene(new RoomEnvironment()).texture
  // 初始化光源
  // initLight()
  // return {
  //   camera,
  //   renderer,
  //   controls,
  //   pmremGenerator,
  //   scene
  // }
  // 初始化光源
  // initLight()    
}
